<div class="container">
  <div class="row">
    <div class="col s12 m6 l4 push-m3 push-l4">
      <mat-card>
        <mat-card-header>
          <!-- <mat-card-title>Forgot Username or Password</mat-card-title> -->
        </mat-card-header>
        <mat-card-content>
          <div class="container">
            <p>If you need assistance resetting your password please contact customer support: (111) 222-3333.</p>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <a routerLink="/" class="btn btn-link">Return to login</a>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
